<template>
  <div>
    <vue-headful title="Accountgegevens" />
    <Header :page_title="this.action !== 'next' ? 'Accountgegevens' : 'Aanmelden'" />
    <div class="app-body container-fluid">
      <form @change="onFormChange" @submit.prevent="onSubmit" class="sd-form">
        <div class="mb-4">
          <NotificationContainer />
          <div class="steps-container" v-if="this.action == 'next'">
            <register-steps :steps="{1:'Gegevens',2:'Aan de slag!'}" totalAnswered="66" currentStep="1" />
            <div class="sd-title medium" style="margin-bottom: 20px;">
              <span class="steps">2/3</span>
              Accountgegevens
            </div>
          </div>
          <div class="form-container">
            <div class="container-organisation">
              <div class="sd-title mini mb-20px right-line">
                <span class="title-text">
                    <svg-icon :icon="form.branch === 3 ? 'healthcare' : 'education'" />
                    Informatie over de organisatie
                </span>
              </div>
              <div class="input-row">
                <div class="sd-input sd-col-12" v-if="this.action !== 'next'">
                  <label for="organisation_name">Naam {{ form.branch === 3 ? 'organisatie' : 'stichting/school' }} <span class="required">*</span></label>
                  <input
                    id="organisation_name"
                    type="text"
                    class="form-control"
                    :class="[this.required.includes('name') ? 'require' : '']"
                    :placeholder="'Naam ' + (form.branch === 3 ? 'organisatie' : 'stichting/school') + ' '"
                    v-model="form.name"
                    autocomplete="nope"
                    required
                  />
                  <span class="extra-info text-left mt-2">
                    <svg-icon icon="information" />
                    Let op: de naam van de organisatie kan geen leestekens bevatten
                  </span>
                </div>
                <div class="sd-input sd-col-12" v-if="this.action !== 'next'">
                  <label for="invoice_email">Naar welk e-mailadres mag de factuur?<span class="required">*</span></label>
                  <input
                    id="invoice_email"
                    type="email"
                    class="form-control"
                    :class="[this.required.includes('invoice_email') ? 'require' : '']"
                    placeholder="Factuur e-mailadres"
                    v-model="form.invoice_email"
                    autocomplete="nope"
                    required
                  />
                </div>
                <div class="sd-input sd-col-12">
                  <label for="organisation_about">Vertel hier iets meer over de organisatie<span v-if="this.required.includes('about')" class="required">*</span></label>
                  <textarea
                    id="organisation_about"
                    v-model="form.about"
                    class="form-control"
                    :class="[this.required.includes('about') ? 'require' : '']"
                    :placeholder="'Vertel hier iets meer over de organisatie' + [this.required.includes('about') ? '*' : '...']"
                    rows="7"
                    spellcheck="false"
                    :required="this.required.includes('about')"
                  ></textarea>
                </div>
              </div>
            </div>
            <div class="container-contactperson">
              <div class="sd-title mini mb-20px right-line">
                <span class="title-text"><svg-icon icon="person_male" />Contactpersoon</span>
              </div>
              <div class="input-row">
                <div class="sd-input sd-col-12 form-group w-square-icon">
                  <label for="salutation">Aanhef<span class="required">*</span></label>
                  <select
                    id="contact_salutation"
                    class="custom-select"
                    :class="[this.required.includes('contact_salutation') && !form.contact_salutation ? '' : '']"
                    v-model="form.contact_salutation"
                    required
                  >
                    <option value selected disabled>Aanhef</option>
                    <option
                      v-for="(val, key) in this.salutations"
                      :key="key"
                      :value="val"
                    >{{ val }}</option>
                  </select>
                  <div class="icon-wrapper dropdown position-absolute align-self-center">
                    <svg-icon icon="chevron_s" />
                  </div>
                </div>
                <div class="sd-input sd-col-4">
                  <label for="contact_firstname">Voornaam<span class="required">*</span></label>
                  <input
                    id="contact_firstname"
                    type="text"
                    class="form-control"
                    :class="[this.required.includes('contact_firstname') ? 'require' : '']"
                    placeholder="Voornaam"
                    v-model="form.contact_firstname"
                    autocomplete="nope"
                    required
                  />
                </div>
                <div class="sd-input sd-col-4">
                  <label for="contact_infix">Tussenvoegsel</label>
                  <input
                    id="contact_infix"
                    type="text"
                    class="form-control"
                    :class="[this.required.includes('contact_infix') ? '' : '']"
                    placeholder="Tussenvoegsel"
                    v-model="form.contact_infix"
                    autocomplete="nope"
                  />
                </div>
                <div class="sd-input sd-col-4">
                  <label for="contact_lastname">Achternaam<span class="required">*</span></label>
                  <input
                    id="contact_lastname"
                    type="text"
                    class="form-control"
                    :class="[this.required.includes('contact_lastname') ? 'require' : '']"
                    placeholder="Achternaam"
                    v-model="form.contact_lastname"
                    autocomplete="nope"
                    required
                  />
                </div>
                <div class="sd-input sd-col-6" v-if="this.action !== 'next'">
                  <label for="contact_email">E-mailadres<span class="required">*</span></label>
                  <input
                    id="contact_email"
                    type="email"
                    class="form-control"
                    placeholder="E-mailadres"
                    v-model="form.email"
                    autocomplete="nope"
                    required
                  />
                </div>
                <div class="sd-input" :class="[this.action == 'next' ? 'sd-col-12' : 'sd-col-6']">
                  <label for="contact_telephone">Mobiel nummer<span class="required">*</span></label>
                  <input
                    id="contact_telephone"
                    type="text"
                    class="form-control"
                    :class="[this.required.includes('telephone') ? 'require' : '']"
                    placeholder="Mobiel nummer"
                    v-model="form.telephone"
                    autocomplete="nope"
                    required
                  />
                </div>
                <div class="sd-input sd-col-12" v-if="this.action !== 'next'">
                  <label for="invoice_email">Welke naam mag er op de overeenkomst?</label>
                  <input
                      id="invoice_name"
                      type="text"
                      class="form-control"
                      placeholder="Voor- en achternaam tekenbevoegde"
                      v-model="form.invoice_name"
                      autocomplete="nope"
                  />
                </div>
              </div>
            </div>
            <div class="container-address">
              <div class="sd-title mini right-line">
                <span class="title-text"><svg-icon icon="address" />Adresgegevens</span>
              </div>
              <div class="sd-input sd-col-12 form-group w-square-icon mt-4 mb-2">
                <label for="salutation">Provincie<span class="required">*</span></label>
                <select
                    id="province"
                    class="custom-select"
                    :class="[this.required.includes('province') && !form.contact_salutation ? '' : '']"
                    v-model="form.province"
                    required
                >
                  <option value selected disabled>Provincie</option>
                  <option
                      v-for="(val, key) in this.provinces"
                      :key="key"
                      :value="val"
                  >{{ val }}</option>
                </select>
                <div class="icon-wrapper dropdown position-absolute align-self-center">
                  <svg-icon icon="chevron_s" />
                </div>
              </div>
              <div class="sd-input sd-col-12 form-group">
                <input
                  v-if="form.type"
                  type="text"
                  name="adres"
                  required
                  v-model="form.lat"
                  style="position: absolute; display: block; opacity: 0; margin: 0; border: 0; padding: 0;"
                  autocomplete="off"
                />
                <router-link
                  v-if="!form.lat && !form.lng && !user"
                  :to="{ name: 'location-add' }"
                  class="btn btn-gray btn-block btn-w-icon"
                >
                  Vul hier je adresgegevens in
                  <i class="material-icons">location_searching</i>
                </router-link>
                <AddressCard
                  v-if="form.lat && form.lng && !user"
                  :address="{
                    name_location: form.name_location,
                    street: form.street,
                    street_number: form.street_number + ' ' + form.house_addition,
                    postal_code: form.postal_code,
                    city: form.city,
                    edit: { name: 'location-add' }
                  }"
                />
                <span v-if="!user" class="extra-info text-left mt-2 mb-4">
                  <svg-icon icon="information" />
                  Je kunt meerdere locaties toevoegen nadat je bent aangemeld.
                </span>
                <div v-if="user" class="mb-3">
                  <AddressCard
                    v-for="address in user.addresses"
                    :key="address.id"
                    :address="address"
                  />
              </div>
            </div>
            <router-link
              v-if="user"
              :to="{ path: '/company/location/add' }"
              title="Add Location"
              class="btn btn-add btn-block position-relative mb-4"
            >
              <div class="icon-wrapper position-absolute">
                <i class="material-icons">add_circle</i>
              </div>
              Voeg locatie toe
            </router-link>
          </div>
            <button
              type="submit"
              class="btn btn-warning btn-block"
              v-ripple="'rgba(255, 255, 255, 0.35)'"
            >
              {{ this.action == "next" ? "Volgende stap" : "Bewaar" }}
            </button>
          </div>
        </div>
      </form>
    </div>
    <Footer v-if="this.action !== 'next'" />
  </div>
</template>

<script>
import AddressCard from "@/components/AddressCard.vue";

export default {
  data: function() {
    return {
      user: null,
      salutations: {
        de_heer: "De heer",
        mevrouw: "Mevrouw",
        nvt: "Nvt"
      },
      provinces: {
        drenthe: "Drenthe",
        flevoland: "Flevoland",
        friesland: "Friesland",
        gelderland: "Gelderland",
        groningen: "Groningen",
        limburg: "Limburg",
        noordBrabant: "Noord-Brabant",
        noordHolland: "Noord-Holland",
        overijssel: "Overijssel",
        utrecht: "Utrecht",
        zeeland: "Zeeland",
        zuidHolland: "Zuid-Holland"
      },
      address: {},
      address_id: null,
      form: {
        branch: localStorage.getItem('branch'),
        name: "",
        email: "",
        about: "",
        invoice_email: "",
        invoice_name: "",
        password: "",
        password_confirmation: "",
        type: 2,
        telephone: "",
        name_location: "",
        street: "",
        street_number: "",
        house_addition: "",
        postal_code: "",
        city: "",
        contact_salutation: "",
        province: "",
        contact_firstname: "",
        contact_infix: "",
        contact_lastname: ""
      },
      old_email: "",
      required: []
    };
  },
  props: ["action"],
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      var obj;
      // the user is logged in
      if (localStorage.getItem("user-token")) {
        await this.updateLocalUser();
        
        this.user = JSON.parse(localStorage.getItem("user"));
        this.address_id = this.user.addresses[0].id;
        // set array required
        this.required = this.$store.state.company_fields;
        this.required = ["about"];

        // remove some form obj properties
        delete this.form["password"];
        delete this.form["password_confirmation"];
        delete this.form["type"];

        // update the form obj from user
        for (obj in this.form) {
          if (this.user[obj]) {
            // user details info match form obj property
            this.form[obj] = this.user[obj]; // update
          }
        }
        this.old_email = JSON.parse(JSON.stringify(this.form.email));
      } else if (localStorage.getItem("user-register")) {
        // the user is NOT YET verified
        const user_register = JSON.parse(localStorage.getItem("user-register"));
        for (obj in user_register) {
          if (user_register[obj] && obj != "type") {
            this.form[obj] = user_register[obj]; // update
          }
        }
        // load the address from form
        const address = JSON.parse(localStorage.getItem("address"));
        if (address) {
          for (obj in address) {
            if (address[obj]) {
              this.form[obj] = address[obj];
            }
          }
        }
      }
    },
    async updateUser() {
      return new Promise(resolve => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/company";
        let formData = new FormData();
        for (var obj in this.form) {
          if (obj != "email") {
            formData.append(obj, this.form[obj]);
          }
        }
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            // console.log(success);
            localStorage.removeItem("form-pending");
            const notification = {
              type: "success",
              message: "Je hebt je gegevens succesvol aangepast. "
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            resolve();
          })
          .catch(() => {
            // console.log(error);
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden.",
                error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
          });
      });
    },
    async updateUserEmail() {
      return new Promise(resolve => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/change_email";
        let formData = new FormData();
        formData.append("email", this.form["email"]);
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(success => {
            localStorage.setItem("force-notif", JSON.stringify(true));
            const notification = {
              type: "success",
              message: success.data.message
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
            resolve();
          })
          .catch(() => {
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden.",
                error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
          });
      });
    },
    async onSubmit() {
      this.$store.state.loading = true;
      if (localStorage.getItem("user-token")) {
        await this.updateUser();

        if (this.old_email != this.form.email) {
          await this.updateUserEmail();
        }

        await this.updateLocalUser();

        window.scrollTo(0, 0);
        if (this.action == "next") {
          this.$router.replace({
            name: "company-step_1"
          });
        } else {
          setTimeout(
            () =>
              this.$router.replace({
                name: "company-dashboard"
              }),
            5000
          );
        }
      } else {
        await this.registerUser(this.form);
      }
      this.$store.state.loading = false;
    },
    onFormChange() {
      // update the localstorage when form is changing
      var obj;
      const user_register = this.form;
      for (obj in user_register) {
        // remove obj property that is empty
        if (user_register[obj] == "") {
          // delete user_register[obj]; // delete
        }
      }

      localStorage.setItem("form-pending", JSON.stringify(true));
      if (!localStorage.getItem("user-token")) {
        localStorage.setItem("user-register", JSON.stringify(user_register));
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    var subpages = ["location-add"];
    if (subpages.indexOf(to.name) > -1) {
      next();
    } else {
      this.savePending(to, from, next);
    }
  },
  components: {
    AddressCard
  }
};
</script>

<style scoped></style>
